/* AVIRI cart drawer: rewards bar, confetti, coupons, upsell. Self-contained. */
(function(){
  /* ================= CONFIG ================= */
  var M1 = 79900,  M1_LABEL = '1 Free Gift';   /* Rs 799  */
  var M2 = 149900, M2_LABEL = '2 Free Gifts';  /* Rs 1499 */
  var FREE_SHIP = 99900;                        /* Rs 999  */
  var MAX = 4;
  var OFFERS = [
    {code:'WELCOME10', desc:'10% off your order'},
    {code:'INSTA10',   desc:'10% off, min order Rs 499'},
    {code:'FREEDOM15', desc:'15% off, min order Rs 1,499'}
  ];


  var GIFT = "<svg viewBox='0 0 24 24' fill='none' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'>"
    + "<polyline points='20 12 20 22 4 22 4 12'></polyline><rect x='2' y='7' width='20' height='5'></rect>"
    + "<line x1='12' y1='22' x2='12' y2='7'></line>"
    + "<path d='M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z'></path>"
    + "<path d='M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z'></path></svg>";

  var lastKey=null, writing=false, timer=null, prevTier=null, activeCode=null;
  var upCache={pid:null, list:null};

  function inr(p){ return '₹' + Math.round(p/100).toLocaleString('en-IN'); }
  function getJSON(u){ return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function inner(){ return document.querySelector('#CartDrawer .drawer__inner'); }
  function header(){ return document.querySelector('#CartDrawer .drawer__header'); }
  function footer(){ return document.querySelector('#CartDrawer .drawer__footer, .cart-drawer__footer'); }
  function scroller(){ return document.querySelector('#CartDrawer cart-drawer-items'); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function tierOf(t){ return t>=M2?2:(t>=M1?1:0); }

  /* ---------------- confetti ---------------- */
  function confetti(){
    try{
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var host=inner(); if(!host) return;
      var r=host.getBoundingClientRect();
      var cv=document.createElement('canvas');
      cv.className='av-confetti'; cv.width=r.width; cv.height=r.height;
      host.appendChild(cv);
      var ctx=cv.getContext('2d');
      var cols=['#8F6B32','#C9A878','#121212','#E4D4B3','#ffffff'];
      var P=[],i;
      for(i=0;i<95;i++){
        P.push({x:cv.width*(0.15+Math.random()*0.7), y:cv.height*0.22,
          vx:(Math.random()-0.5)*6.5, vy:Math.random()*-8-2,
          w:4+Math.random()*5, h:6+Math.random()*7,
          rot:Math.random()*6.28, vr:(Math.random()-0.5)*0.32,
          c:cols[(Math.random()*cols.length)|0]});
      }
      var t0=Date.now();
      (function frame(){
        var el=Date.now()-t0;
        ctx.clearRect(0,0,cv.width,cv.height);
        for(var j=0;j<P.length;j++){
          var p=P[j];
          p.vy+=0.24; p.x+=p.vx; p.y+=p.vy; p.rot+=p.vr;
          ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.rot);
          ctx.globalAlpha=Math.max(0,1-el/2000); ctx.fillStyle=p.c;
          ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h); ctx.restore();
        }
        if(el<2000){ requestAnimationFrame(frame); } else { cv.remove(); }
      })();
    }catch(e){}
  }

  /* ---------------- rewards bar ---------------- */
  function renderRewards(cart){
    var hd=header(); if(!hd) return;
    var el=document.getElementById('av-rw');
    if(!el){ el=document.createElement('div'); el.id='av-rw'; el.className='av-rw'; hd.insertAdjacentElement('afterend',el); }
    var t=cart.total_price, pct, msg;
    if(t<M1){ pct=(t/M1)*50; msg="Add <b>"+inr(M1-t)+"</b> more to unlock your <span class='av-hl'>1st free gift</span>"; }
    else if(t<M2){ pct=50+((t-M1)/(M2-M1))*50; msg="<span class='av-hl'>1 free gift unlocked!</span> Add <b>"+inr(M2-t)+"</b> more for your 2nd gift"; }
    else { pct=100; msg="You have unlocked <span class='av-hl'>all rewards</span> &mdash; 2 free gifts"; }
    if(!cart.item_count){ msg="Spend <b>"+inr(M1)+"</b> to unlock a <span class='av-hl'>free gift</span>"; }
    var on1=t>=M1, on2=t>=M2;
    var markPct=Math.max(4,Math.min(96,pct));
    el.innerHTML =
      "<p class='av-rw-msg'>"+msg+"</p>"
      + "<div class='av-rw-wrap'>"
      +   "<div class='av-rw-mark' style='left:"+markPct+"%'>"+inr(t)+"</div>"
      +   "<div class='av-rw-track'><div class='av-rw-fill' style='width:"+pct+"%'></div>"
      +     "<div class='av-rw-node"+(on1?' on':'')+"' style='left:50%'>"+GIFT+"</div>"
      +     "<div class='av-rw-node"+(on2?' on':'')+"' style='left:100%'>"+GIFT+"</div>"
      +   "</div>"
      +   "<div class='av-rw-labels'>"
      +     "<div class='av-rw-lab"+(on1?' on':'')+"' style='left:50%'><b>"+M1_LABEL+"</b>"+inr(M1)+"</div>"
      +     "<div class='av-rw-lab"+(on2?' on':'')+"' style='left:100%'><b>"+M2_LABEL+"</b>"+inr(M2)+"</div>"
      +   "</div>"
      + "</div>";
    var tier=tierOf(t);
    if(prevTier!==null && tier>prevTier){ confetti(); }
    prevTier=tier;
  }

  /* ---------------- header + chips ---------------- */
  function renderMeta(cart){
    var h=document.querySelector('#CartDrawer .drawer__heading');
    if(h) h.textContent='Your Cart ('+cart.item_count+(cart.item_count===1?' item)':' items)');
    var host=footer(); if(!host) return;
    var chip=document.getElementById('av-chips');
    if(!chip){ chip=document.createElement('div'); chip.id='av-chips'; host.insertBefore(chip,host.firstChild); }
    var html='';
    if(cart.original_total_price>cart.total_price){
      html+="<span class='av-save'>You save "+inr(cart.original_total_price-cart.total_price)+"</span>";
    }
    html += cart.total_price>=FREE_SHIP
      ? "<span class='av-ship-chip'>FREE shipping included</span>"
      : "<span class='av-ship-chip av-off'>"+inr(FREE_SHIP-cart.total_price)+" more for free shipping</span>";
    chip.innerHTML=html;
  }

  /* ---------------- coupons ---------------- */
  function couponMsg(el,text,ok){ el.textContent=text; el.className='av-cp-msg on '+(ok?'ok':'bad'); }

  function couponFailMsg(cart, code){
    var known = OFFERS.some(function(o){ return o.code.toUpperCase()===String(code||'').toUpperCase(); });
    if(!known) return 'Invalid code. Please check and try again.';
    var others=(cart.cart_level_discount_applications||[]);
    return others.length ? 'A better offer is already applied to your cart.' : 'Not applied yet. Check the code or its minimum order value.';
  }

  function fetchDrawerSections(code, delay, triesLeft){
    return new Promise(function(res){ setTimeout(res,delay); })
      .then(function(){ return fetch('/cart/update.js?_='+Date.now(),{method:'POST',cache:'no-store',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({updates:{},sections:'cart-drawer,cart-icon-bubble'})}); })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var html=(c.sections && c.sections['cart-drawer']) || '';
        var mineApplicable = (c.discount_codes||[]).some(function(d){ return d.applicable && d.code.toUpperCase()===code.toUpperCase(); });
        var hasThisCodeLine = mineApplicable && new RegExp(code.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'),'i').test(html);
        if(mineApplicable && !hasThisCodeLine && triesLeft>0){ return fetchDrawerSections(code,700,triesLeft-1); }
        return c;
      });
  }

  function applyCode(code, msgEl, btn){
    if(!code) return;
    activeCode=code;
    var old=btn.textContent; btn.disabled=true; btn.textContent='...';
    fetch('/discount/'+encodeURIComponent(code),{method:'GET',credentials:'same-origin'})
      .then(function(){ return fetchDrawerSections(code,400,9); })
      .then(function(c){
        var cd=document.querySelector('cart-drawer');
        if(cd && c.sections && typeof cd.renderContents==='function'){ cd.renderContents(c); }
        var codes=(c.discount_codes||[]).filter(function(d){ return d.code; });
        var mine=codes.filter(function(d){ return d.code.toUpperCase()===code.toUpperCase(); }).pop();
        btn.disabled=false; btn.textContent=old;
        if(mine){ couponMsg(msgEl, mine.applicable?('Coupon "'+mine.code+'" applied to your cart'):couponFailMsg(c,code), !!mine.applicable); }
        else { couponMsg(msgEl,'Not applied. Check the code and try again.',false); }
        refresh(true);
      })
      .catch(function(){ couponMsg(msgEl,'Could not apply right now. Please try again.',false);
        btn.disabled=false; btn.textContent=old; });
  }

  function syncCouponState(cart){
    var msgEl=document.querySelector('.av-cp-msg'); if(!msgEl) return;
    var btn=document.querySelector('.av-cp-btn'); if(btn && btn.disabled) return; /* apply in flight, don't fight it */
    if(!activeCode) return;
    var codes=(cart.discount_codes||[]).filter(function(d){ return d.code; });
    var d=codes.filter(function(c){ return c.code.toUpperCase()===activeCode.toUpperCase(); }).pop();
    if(!d) return;
    if(d.applicable){ couponMsg(msgEl,'Coupon "'+d.code+'" applied to your cart',true); }
    else { couponMsg(msgEl,couponFailMsg(cart,activeCode),false); }
  }

  function renderCoupon(cart){
    var host=scroller(); if(!host||!cart.item_count){ var o=document.getElementById('av-cp'); if(o) o.remove(); return; }
    if(!document.getElementById('av-cp')){
      var box=document.createElement('div'); box.id='av-cp'; box.className='av-cp';
      box.innerHTML =
        "<div class='av-cp-row'><span class='av-cp-ic'>%</span>"
        + "<input class='av-cp-in' type='text' placeholder='Enter Coupon Code' autocomplete='off' spellcheck='false'>"
        + "<button type='button' class='av-cp-btn'>Apply</button></div>"
        + "<div class='av-cp-msg'></div>"
        + "<button type='button' class='av-cp-tog'>View All Offers &rsaquo;</button>"
        + "<div class='av-cp-list'>" + OFFERS.map(function(o){
            return "<div class='av-of'><div><div class='av-of-c'>"+esc(o.code)+"</div>"
              + "<div class='av-of-d'>"+esc(o.desc)+"</div></div>"
              + "<button type='button' class='av-of-a' data-code='"+esc(o.code)+"'>Apply</button></div>";
          }).join('') + "</div>";
      host.appendChild(box);
    }
    syncCouponState(cart);
  }

  /* ---------------- upsell ---------------- */
  function paintUpsell(host, cart, products){
    var have={}; cart.items.forEach(function(i){ have[i.product_id]=1; });
    var list=(products||[]).filter(function(p){ return !have[p.id] && p.available; }).slice(0,MAX);
    var b=document.getElementById('av-up');
    if(!list.length){ if(b) b.remove(); return; }
    if(!b){ b=document.createElement('div'); b.id='av-up'; b.className='av-up'; host.appendChild(b); }
    writing=true;
    b.innerHTML="<div class='av-up-h'>Recommended For You</div><div class='av-up-r'>"+list.map(function(p){
          var img=p.featured_image?esc(p.featured_image)+'&width=160':'';
          var was=(p.compare_at_price && p.compare_at_price>p.price)?p.compare_at_price:0;
          var off=was?Math.round((was-p.price)/was*100):0;
          return "<div class='av-c'>"
            + "<a class='av-c-img' href='"+esc(p.url)+"' tabindex='-1'><img src='"+img+"' alt='' loading='lazy'>"
            + (off?"<span class='av-badge'>"+off+"% OFF</span>":"") + "</a>"
            + "<div class='av-c-mid'>"
            + "<a class='av-n' href='"+esc(p.url)+"'>"+esc(p.title)+"</a>"
            + "<div class='av-pr'><span class='av-p'>"+inr(p.price)+"</span>"
            + (was?"<span class='av-was'>"+inr(was)+"</span>":"") + "</div>"
            + "</div>"
            + "<button type='button' class='av-add' data-vid='"+p.variants[0].id+"'>+ Add</button></div>";
        }).join('')+"</div>";
    setTimeout(function(){ writing=false; },60);
  }

  function renderUpsell(cart){
    var host=scroller(); if(!host) return;
    var box=document.getElementById('av-up');
    if(!cart.items.length){ if(box) box.remove(); return; }
    var pid=cart.items[0].product_id;
    if(upCache.pid===pid && upCache.list){ paintUpsell(host,cart,upCache.list); return; }
    getJSON('/recommendations/products.json?product_id='+pid+'&limit=12&intent=related')
      .then(function(d){
        upCache.pid=pid; upCache.list=d.products||[];
        paintUpsell(host,cart,upCache.list);
      }).catch(function(){});
  }

  function refresh(force){
    if(!inner()) return;
    getJSON('/cart.js').then(function(cart){
      var key=cart.item_count+':'+cart.total_price;
      if(!force && key===lastKey && document.getElementById('av-rw')) return;
      lastKey=key; writing=true;
      renderRewards(cart); renderMeta(cart); renderCoupon(cart); renderUpsell(cart);
      setTimeout(function(){ writing=false; },60);
    }).catch(function(){});
  }

  /* ---------------- events ---------------- */
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var tog=e.target.closest('.av-cp-tog');
    if(tog){ e.preventDefault(); var l=document.querySelector('.av-cp-list'); if(l) l.classList.toggle('on'); return; }
    var of=e.target.closest('.av-of-a');
    if(of){ e.preventDefault(); var inp=document.querySelector('.av-cp-in');
      if(inp) inp.value=of.dataset.code;
      applyCode(of.dataset.code, document.querySelector('.av-cp-msg'), of); return; }
    var cb=e.target.closest('.av-cp-btn');
    if(cb){ e.preventDefault(); var i2=document.querySelector('.av-cp-in');
      applyCode(i2?i2.value.trim():'', document.querySelector('.av-cp-msg'), cb); return; }
    var btn=e.target.closest('.av-add');
    if(!btn) return;
    e.preventDefault();
    var label=btn.textContent; btn.disabled=true; btn.textContent='Adding';
    fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(btn.dataset.vid,10),quantity:1}],sections:'cart-drawer,cart-icon-bubble'})})
      .then(function(r){return r.json();})
      .then(function(res){
        var cd=document.querySelector('cart-drawer');
        if(cd&&res.sections&&typeof cd.renderContents==='function'){ cd.renderContents(res); }
        setTimeout(function(){ refresh(true); },250);
      })
      .catch(function(){ btn.disabled=false; btn.textContent=label; });
  });

  document.addEventListener('keydown', function(e){
    if(e.key==='Enter' && e.target && e.target.classList && e.target.classList.contains('av-cp-in')){
      e.preventDefault();
      applyCode(e.target.value.trim(), document.querySelector('.av-cp-msg'), document.querySelector('.av-cp-btn'));
    }
  });

  function watch(){
    var d=document.querySelector('cart-drawer'); if(!d) return;
    new MutationObserver(function(){
      if(writing) return;
      clearTimeout(timer);
      timer=setTimeout(function(){ refresh(false); },250);
    }).observe(d,{childList:true,subtree:true});
  }
  function boot(){ refresh(true); watch(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();
